import { configureStore } from '@reduxjs/toolkit'
import { createManagedCollection } from '../../vendor/react-relaxful/relax/collectionCreator'

export const globalStore = createManagedCollection(null, {
    subscribeObituary: 'v1/subscriptions',
    subscribeDailyGrief: 'v1/subscriptions'
})

const reducers = {}
Object.entries(globalStore).forEach(([name, entity]) => (reducers[`${name}Reducer`] = entity.reducer))

/**
 * Root Redux Store
 */
export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    devTools: import.meta.env.VITE_APP_ENV !== 'production',
})
